import moment from "moment";
import logo from "../../../asset/images/logo.png";
import gulfLogo from "../../../asset/images/gulf-logo.png";
import Edition from "../../../Config/edition.json";

const gulfEditions = Edition.filter((e) => e.type === "gulf").map((e) => e.value);

const CropImage = async (
  ratio: any,
  imageRef: any,
  urls: any,
  edition: any
) => {
  return new Promise(async (resolve, reject) => {
    try {
      if (imageRef) {
        imageRef.crossOrigin = "anonymous";
        imageRef.onload = async function (owner: any) {
          const canvas = document.createElement("canvas");

          // Calculate the actual scale factors based on natural vs display dimensions
          const scaleX = imageRef.naturalWidth / imageRef.width;
          const scaleY = imageRef.naturalHeight / imageRef.height;

          // Calculate the actual crop dimensions in the original image space
          const actualCropX = ratio.x! * scaleX;
          const actualCropY = ratio.y! * scaleY;
          const actualCropWidth = ratio.width! * scaleX;
          const actualCropHeight = ratio.height! * scaleY;

          // Set canvas size to the actual cropped dimensions (no additional scaling needed)
          canvas.width = actualCropWidth;
          canvas.height = actualCropHeight;

          const ctx = canvas.getContext("2d")!;

          // Enable high-quality image rendering
          ctx.imageSmoothingEnabled = true;
          ctx.imageSmoothingQuality = "high";

          // Draw the main image at full resolution
          ctx.drawImage(
            imageRef,
            actualCropX,
            actualCropY,
            actualCropWidth,
            actualCropHeight,
            0,
            0,
            actualCropWidth,
            actualCropHeight
          );

          try {
            const watermarkImg = new Image();
            watermarkImg.crossOrigin = "anonymous";

            await new Promise((resolve, reject) => {
              watermarkImg.onload = () => {
                // Compute width so 3 watermarks + 2 gaps + margins fit horizontally
                const outerMargin = 16; // px
                const gapBetween = Math.max(
                  16,
                  Math.floor(canvas.width * 0.03)
                );
                const maxByLayout =
                  (canvas.width - outerMargin * 2 - gapBetween * 2) / 3;
                const maxByPercent = canvas.width * 0.22; // 22% cap per watermark
                const watermarkWidth = Math.floor(
                  Math.min(maxByLayout, maxByPercent)
                );
                const watermarkHeight = Math.floor(
                  (watermarkWidth * watermarkImg.height) / watermarkImg.width
                );

                // Slightly higher opacity for better visibility
                ctx.globalAlpha = 0.32;

                // Vertical positions
                const yCenter = Math.floor(
                  (canvas.height - watermarkHeight) / 2
                );
                // Place side watermarks just BELOW center by a small offset
                const liftBelow = Math.max(4, Math.floor(canvas.height * 0.02));
                const ySide = Math.min(
                  canvas.height - watermarkHeight - outerMargin,
                  yCenter + liftBelow
                );

                // Explicit horizontal positions to guarantee spacing
                const xLeft = outerMargin;
                const xCenter = Math.floor((canvas.width - watermarkWidth) / 2);
                const xRight = canvas.width - outerMargin - watermarkWidth;

                // Draw three identical watermarks
                ctx.drawImage(
                  watermarkImg,
                  xLeft,
                  ySide,
                  watermarkWidth,
                  watermarkHeight
                ); // left (centered vertically)
                ctx.drawImage(
                  watermarkImg,
                  xCenter,
                  yCenter,
                  watermarkWidth,
                  watermarkHeight
                ); // center
                ctx.drawImage(
                  watermarkImg,
                  xRight,
                  ySide,
                  watermarkWidth,
                  watermarkHeight
                ); // right (centered vertically)

                ctx.globalAlpha = 1.0;
                resolve(true);
              };

              watermarkImg.onerror = () => {
                console.log("Watermark failed to load");
                resolve(false);
              };

              watermarkImg.src = gulfEditions.includes(edition) ? gulfLogo : logo;
            });
          } catch (watermarkError) {
            console.log("Error applying watermark:", watermarkError);
          }

          // Use maximum quality for PNG export
          const dataUrl = canvas.toDataURL("image/png", 1.0);
          const blob = dataURLtoBlob(dataUrl);
          let name = moment(new Date()).unix();
          let url = new File([blob], name + "-crop.png", { type: "image/png" });
          resolve(url);
          imageRef.crossOrigin = "";
        };
        imageRef.src = urls;
        imageRef.onerror = function () {
          imageRef.crossOrigin = "";
          console.log("image load failed");
        };
      } else {
        resolve("error");
      }
    } catch (err) {
      console.log("err", err);
      resolve("error");
    }
  });
};

const dataURLtoBlob = (dataURL: string) => {
  const arr = dataURL.split(",");
  const mime = arr[0].match(/:(.*?);/)![1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
};

export default CropImage;
